import { useState } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { storage, Db } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const UploadEvent = () => {
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [location, setLocation] = useState("");
  const [images, setImages] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [progress, setProgress] = useState(0);
  const [dragActive, setDragActive] = useState(false);

  const handleFiles = (files) => {
    const valid = Array.from(files).filter((file) => file.type.startsWith("image/"));
    setImages((prev) => [...prev, ...valid]);
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFiles(e.dataTransfer.files);
      e.dataTransfer.clearData();
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (images.length === 0) return alert("📸 Επίλεξε ή ρίξε τουλάχιστον μία φωτογραφία!");

    setUploading(true);
    setSuccess(false);
    setProgress(0);

    try {
      const imageUrls = [];
      let completed = 0;

      for (const image of images) {
        const imageRef = ref(storage, `event_photos/${Date.now()}_${image.name}`);
        const uploadTask = uploadBytesResumable(imageRef, image);

        await new Promise((resolve, reject) => {
          uploadTask.on(
            "state_changed",
            (snapshot) => {
              const currentProgress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              setProgress(Math.round((completed / images.length) * 100 + currentProgress / images.length));
            },
            (error) => reject(error),
            async () => {
              const url = await getDownloadURL(uploadTask.snapshot.ref);
              imageUrls.push(url);
              completed++;
              setProgress(Math.round((completed / images.length) * 100));
              resolve();
            }
          );
        });
      }

      await addDoc(collection(Db, "event_photos"), {
        title,
        date,
        location,
        images: imageUrls,
        createdAt: serverTimestamp(),
      });

      setTitle("");
      setDate("");
      setLocation("");
      setImages([]);
      setSuccess(true);
    } catch (error) {
      console.error("🔥 Σφάλμα στο ανέβασμα φωτογραφιών:", error);
      alert("Πρόβλημα κατά το ανέβασμα!");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="container my-5 text-white">
      <h3 className="fw-bold text-center mb-4">📸 Upload Event Photos</h3>
      <Form onSubmit={handleUpload} className="p-4 rounded shadow bg-dark">
        <Form.Group className="mb-3">
          <Form.Label>Event Title</Form.Label>
          <Form.Control
            type="text"
            placeholder="π.χ. Brutal Death Fest 2025"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Date</Form.Label>
          <Form.Control
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>location</Form.Label>
          <Form.Control
            type="text"
            placeholder="For example 'Ruins of the rats nest'"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            required
          />
        </Form.Group>

        {/* ✅ Drag & Drop πεδίο */}
        <div
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
          className={`border rounded p-4 text-center mb-3 ${
            dragActive ? "border-danger bg-secondary bg-opacity-25" : "border-secondary"
          }`}
          style={{ cursor: "pointer" }}
        >
          <p className="mb-0">
            {dragActive
              ? "🩸 Drop images here "
              : "📂 Select Files"}
          </p>
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={(e) => handleFiles(e.target.files)}
            className="d-none"
            id="fileUpload"
          />
          <label htmlFor="fileUpload" className="btn btn-outline-light btn-sm mt-2">
            Επιλογή αρχείων
          </label>
        </div>

        {/* ✅ Προεπισκόπηση εικόνων */}
        {images.length > 0 && (
          <div className="d-flex flex-wrap gap-2 mb-3 justify-content-center">
            {images.map((img, i) => (
              <img
                key={i}
                src={URL.createObjectURL(img)}
                alt={`preview-${i}`}
                className="rounded"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  border: "1px solid #444",
                }}
              />
            ))}
          </div>
        )}

        {/* Progress Bar */}
        {uploading && (
          <div className="progress mb-3" style={{ height: "8px" }}>
            <div
              className="progress-bar bg-danger"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        )}

        <Button
          variant="danger"
          type="submit"
          className="w-100 fw-bold py-2"
          disabled={uploading}
        >
          {uploading ? (
            <>
              <Spinner animation="border" size="sm" /> Ανέβασμα...
            </>
          ) : (
            "Upload"
          )}
        </Button>

        {success && (
          <p className="text-success text-center mt-3 fw-semibold">
            ✅ 
          </p>
        )}
      </Form>
    </div>
  );
};

export default UploadEvent;
